export default "__VITE_PUBLIC_ASSET__f209893d__"